import { render, staticRenderFns } from "./Discord.vue?vue&type=template&id=72e26b6a&scoped=true&"
import script from "./Discord.vue?vue&type=script&lang=js&"
export * from "./Discord.vue?vue&type=script&lang=js&"
import style0 from "./Discord.vue?vue&type=style&index=0&id=72e26b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e26b6a",
  null
  
)

export default component.exports